import { useAreAiWorkflowActionsEnabled } from "@/react/components/SettingsApp/Workflows/components/Actions/AiAgents/reportPost/useAreAiWorkflowActionsEnabled";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

interface UseShouldShowAiModalOptions {
  categories?: string[];
  isAiWorkflowCategoryRequired?: boolean;
}

export const useShouldShowAiModal = ({
  isAiWorkflowCategoryRequired = false,
  categories = [],
}: UseShouldShowAiModalOptions = {}) => {
  // [TODO][AIActionsBilling][AfterRelease] Use a plan feature flag instead
  const { isCommunityOnEnterprise, isCommunityOnPlus } = usePlanStatus();
  const isAiActionsBillingEnabled = useAreAiWorkflowActionsEnabled();

  const AI_WORKFLOWS_CATEGORY = "ai_workflows";
  const hasAiWorkflowsCategory = categories.includes(AI_WORKFLOWS_CATEGORY);
  const isCategoryRequirementMet =
    !isAiWorkflowCategoryRequired || hasAiWorkflowsCategory;

  return (
    isAiActionsBillingEnabled &&
    !isCommunityOnEnterprise &&
    !isCommunityOnPlus &&
    isCategoryRequirementMet
  );
};
